import React from "react";
import "./Badge.css";

type BadgeProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: "default" | "secondary" | "destructive" | "outline";
};

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return <div className={`badge ${variant} ${className || ""}`} {...props} />;
}

export { Badge };
